// Constantes y utilerías de pantalla del RMA de compras (devoluciones a proveedores).
// Gemelo de backend: erp_backend/Utils/rmaCompra/constantes.rmaCompra.js (los números de estado).
// Lo que no depende del origen (dinero, cantidades, importe, PDF en iframe) es lo del RMA de ventas.
export { cantidadTexto, dinero, importeConImpuestosMXN, mostrarPdfEnIframe } from "../RMA/rmaComun";

export const ESTADOS_RMA_COMPRA = {
  CANCELADO: 0,
  BORRADOR: 1,
  SOLICITADO: 2,
  AUTORIZADO: 3,
  RECHAZADO: 4,
  ENVIADO: 5,
  POR_RESOLVER: 6,
  CERRADO: 7,
};

export const ETIQUETA_ESTADO_RMA_COMPRA = {
  0: { texto: "Cancelado", color: "red" },
  1: { texto: "Borrador", color: "default" },
  2: { texto: "Solicitado al proveedor", color: "gold" },
  3: { texto: "Autorizado por el proveedor", color: "blue" },
  4: { texto: "Rechazado por el proveedor", color: "volcano" },
  5: { texto: "Enviado", color: "cyan" },
  6: { texto: "Por resolver", color: "purple" },
  7: { texto: "Cerrado", color: "green" },
};

export const ESTADOS_EDITABLES = [ESTADOS_RMA_COMPRA.BORRADOR, ESTADOS_RMA_COMPRA.RECHAZADO];

// Valor del filtro de la lista: 0-7 un estado, 8 abiertos, 9 todos (igual que selectRMAsCompra).
export const VALOR_ABIERTOS = 8;
export const VALOR_TODOS = 9;

// Pasos del expediente, para la barra de avance de la vista.
export const PASOS_RMA_COMPRA = ["Solicitud", "Autorización del proveedor", "Envío", "Resolución", "Cerrado"];

export const pasoDeEstado = (estado) => {
  switch (estado) {
    case ESTADOS_RMA_COMPRA.BORRADOR:
      return 0;
    case ESTADOS_RMA_COMPRA.SOLICITADO:
    case ESTADOS_RMA_COMPRA.RECHAZADO:
      return 1;
    case ESTADOS_RMA_COMPRA.AUTORIZADO:
    case ESTADOS_RMA_COMPRA.ENVIADO:
      return 2;
    case ESTADOS_RMA_COMPRA.POR_RESOLVER:
      return 3;
    case ESTADOS_RMA_COMPRA.CERRADO:
      return 4;
    default:
      return 0;
  }
};

// "Factura F-123" o "Remisión R-45": las facturas de proveedor no tienen serie ni folio.
export const etiquetaFacturaRenglon = (renglon = {}) =>
  `${renglon.esRemision ? "Remisión" : "Factura"} ${renglon.codigoFactura || ""}`.trim();
